import { Avatar, Row } from "antd";
import { ReactNode, useCallback, useMemo } from "react";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

type OptionProps = {
  icon: ReactNode;
  title: string;
  path: string;
  mobileOnly?: boolean;
  mobileHidden?: boolean;
};

export const Option = ({
  icon,
  title,
  path,
  mobileHidden,
  mobileOnly,
}: OptionProps) => {
  const navigate = useNavigate();

  const navigateTo = useCallback(() => {
    navigate(path);
  }, [navigate, path]);

  const containerClassName: string = useMemo(() => {
    if (mobileHidden) {
      return `align-center px-4 py-2 logo-cursor clickable-item justify-space-between mobile-hidden`;
    }

    if (mobileOnly) {
      return `align-center px-4 py-2 logo-cursor clickable-item justify-space-between only-mobile`;
    }

    return `align-center px-4 py-2 logo-cursor clickable-item justify-space-between`;
  }, [mobileHidden, mobileOnly]);

  return (
    <Row className={containerClassName} onClick={navigateTo}>
      <Row className="align-center">
        <Avatar
          icon={icon}
          size={40}
          className="option d-flex justify-center"
        />
        <p className="my-0 text-md w-500 ml-4">{title}</p>
      </Row>
      <RightOutlined />
    </Row>
  );
};
